var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.row.status)?_c('div',{staticClass:"color-green "},[_vm._v(" "+_vm._s(_vm.$timetransition(_vm.row.closeTime))+" ")]):_c('div',{staticClass:"color-red"},[_vm._v(" "+_vm._s(_vm.timeInterval(_vm.row.happenTime))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }